module.exports = __webpack_public_path__ + "static/media/twitter.83320cf1.svg";